// extracted by mini-css-extract-plugin
export default {"root":"vx8y2"};